import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, setToken } from "@/admin/api";

const inputClass =
  "w-full rounded-xl border border-slate-200 bg-white px-4 py-3.5 text-base text-[#0F172A] placeholder:text-slate-400 outline-none transition-all focus:border-[#0FA89E] focus:ring-4 focus:ring-[rgba(15,168,158,0.1)]";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const data = await api("/api/auth/login", {
        method: "POST",
        body: JSON.stringify({ email, password }),
      });
      setToken(data.token);
      navigate("/admin");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFC] flex items-center justify-center px-4">
      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 sm:p-10 shadow-[0_30px_60px_-30px_rgba(15,23,42,0.12)]"
      >
        <p className="font-mono-tech text-xs uppercase tracking-[0.25em] text-[#0FA89E] font-semibold mb-3">
          May Forward Tech
        </p>
        <h1 className="font-display text-2xl sm:text-3xl font-semibold tracking-tight text-[#0F172A] mb-8">
          Admin sign in
        </h1>
        {error && (
          <div
            data-testid="admin-login-error"
            className="mb-6 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700"
          >
            {error}
          </div>
        )}
        <div className="mb-5">
          <label htmlFor="admin-email" className="block text-sm font-semibold text-slate-700 mb-2">
            Email
          </label>
          <input
            id="admin-email"
            data-testid="admin-login-email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="admin@mayforward.com"
            className={inputClass}
          />
        </div>
        <div className="mb-8">
          <label htmlFor="admin-password" className="block text-sm font-semibold text-slate-700 mb-2">
            Password
          </label>
          <input
            id="admin-password"
            data-testid="admin-login-password"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            className={inputClass}
          />
        </div>
        <button
          type="submit"
          data-testid="admin-login-submit"
          disabled={loading}
          className="w-full inline-flex items-center justify-center gap-2.5 rounded-full bg-[#0FA89E] px-8 py-4 text-base font-semibold text-white transition-all hover:bg-[#0C8E85] disabled:opacity-60"
        >
          {loading ? (
            <>
              <Loader2 className="w-4 h-4 animate-spin" />
              Signing in...
            </>
          ) : (
            "Sign in"
          )}
        </button>
      </form>
    </div>
  );
}
